import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  activeShare: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ACTIVE_SHARE:
      return {
        ...state,
        activeShare: action.share,
        propertyStatuses: action.statuses
      }
    default:
      return state
  }
}

export default reducer
